import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { onKeyUpFunction, onKeyDownFunction } from '@utils/a11y';

const Knob = styled.span`
  align-items: center;
  border-radius: 50%;
  left: 0;
  padding: 1px;
  overflow: visible;
  position: absolute;
  text-align: center;
  top: 0;
  transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  z-index: 1;
`;

const Track = styled.span`
  background-color: rgba(120, 120, 128, 0.16);
  border-radius: 13px;
  height: 100%;
  transition: 0.4s;
  width: 100%;
`;

const Container = styled.span`
  display: inline-flex;
  box-sizing: border-box;
  flex-shrink: 0;
  height: 26px;
  margin: 8px;
  padding: 0;
  overflow: hidden;
  position: relative;
  transition: 0.6s;
  width: 42px;
  z-index: 0;
  cursor: pointer;

  ${({ checked }) =>
    checked &&
    css`
      ${Knob} {
        transform: translateX(16px);
      }

      ${Track} {
        background-color: ${({ theme }) => theme.colors.deep_purple};
      }
    `}
`;

const Thumb = styled.span`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  height: 24px;
  width: 24px;
`;

const Label = styled.span`
  align-items: inherit;
  display: flex;
  justify-content: inherit;
  width: 100%;
`;

function Switch({ disabled, isChecked, toggleCheckbox }) {
  const handleOnPress = useCallback(() => {
    if (!disabled) {
      toggleCheckbox(!isChecked);
    }
  }, [disabled, isChecked, toggleCheckbox]);

  return (
    <Container
      role="switch"
      tabIndex={0}
      checked={isChecked}
      aria-checked={isChecked}
      onClick={handleOnPress}
      onKeyUp={e => onKeyUpFunction(e, handleOnPress)}
      onKeyDown={e => onKeyDownFunction(e, handleOnPress)}
    >
      <Knob>
        <Label>
          <Thumb />
        </Label>
      </Knob>
      <Track />
    </Container>
  );
}

Switch.propTypes = {
  disabled: PropTypes.bool,
  isChecked: PropTypes.bool.isRequired,
  toggleCheckbox: PropTypes.func.isRequired,
};

export default Switch;
